import { render, staticRenderFns } from "./reCaptcha.vue?vue&type=template&id=0ab6f730&"
import script from "./reCaptcha.vue?vue&type=script&lang=js&"
export * from "./reCaptcha.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports